import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "share-api-polyfill";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueMeta from "vue-meta";
import OtpInput from "@bachdgvn/vue-otp-input";
// import firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/remote-config";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/app";
import "firebase/compat/messaging";
import "firebase/compat/remote-config";

// import { getMessaging } from "firebase/messaging";
import LinkPrevue from "link-prevue";
import linkify from "vue-linkify";
import parseISO from "date-fns/parseISO";
import format from "date-fns/format";
import moment from "moment";
import "moment-timezone";
import "./common/userSession";
// vue flicker
import Flicking from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
Vue.use(Flicking);
// import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
// import lottie from ''
// Vue.use(LottieVuePlayer);
// vue bootstrap
// import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap and BootstrapVue CSS files (order is important)
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

moment().tz("Asia/Kolkata");

Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.component("v-otp-input", OtpInput);
Vue.use(LinkPrevue);

Vue.prototype.tempAxios = axios.create({
  baseURL: process.env.VUE_APP_MICROSERIVICE_URL,
});

// Make BootstrapVue available throughout your pr3oject
// Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin);

axios.defaults.baseURL =
  process.env.VUE_APP_API_BASE_URL || "http://localhost:8000";
axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.xsrfCookieName = "csrftoken";
Vue.prototype.$axios = axios;
store.$axios = axios;

// axios.interceptors.response.use(
//   (response) => console.log(response,"in main"),
//   (error) => console.log(error)
// );

Vue.directive("linkified", linkify);

// Service worker👇
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then(registration => {
//         console.log('Service Worker registered with scope:', registration.scope);
//       })
//       .catch(error => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }

// Appcuse
// const id = localStorage.getItem("user_id");
// window.Appcues.identify(id, {});

const firebaseConfig = {
  apiKey: "AIzaSyBArBCmPeEga_in92wQZ76fCtQneHXR4xY",
  authDomain: "covesto-693b6.firebaseapp.com",
  projectId: "covesto-693b6",
  storageBucket: "covesto-693b6.appspot.com",
  messagingSenderId: "458763312629",
  appId: "1:458763312629:web:246f58c1b01854ff2ed4bc",
  measurementId: "G-W2YDTTX3P7",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
// const messaging = getMessaging(firebaseApp);
const messaging = firebase.messaging();
Vue.prototype.firebaseApp = firebaseApp;

(function () {
  function showNotification(title, options) {
    return self.registration.showNotification(title, options);
  }
  let url;
  if (process.env.NODE_ENV === "production") {
    url = "https://covesto.in/notifications";
  } else {
    url = "https://www.dev-app.covesto.in/";
  }
  // Vue.prototype.messaging = messaging;
  messaging.onMessage(function (payload) {
    const title = "Covesto";
    const options = {
      body: payload.data.message,
      icon: "Logo.svg",
      data: {
        click_action: url,
      },
    };
    Vue.prototype.eventBus.$emit("update-notifications");

    console.log(options, "options");
    store.dispatch("snackBar/showSnack", {
      text: payload.data.message,
      color: "green",
    });
    // self.registration.showNotification(title, options);
    showNotification(title, options);
  });
})();

Vue.prototype.$logEvent = (arg) => {
  // Add event to Google Tag Manager data layer
  window.dataLayer.push({ event: arg });
};

const remoteConfig = firebase.remoteConfig();
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
remoteConfig.defaultConfig = {
  showFacebookSSOButton: false,
};

Vue.prototype.$firebase = firebase;

Vue.filter("formatTimestamp", (value) => {
  return format(parseISO(value), "HH:mm aaa, d MMM");
});

Vue.filter("reduceToInitials", (value) => {
  if (!value) return "";
  return value
    .replace(/\s*(\S)\S*/g, "$1")
    .toUpperCase()
    .slice(0, 2);
});

Vue.prototype.eventBus = new Vue();

Vue.prototype.$featureFlags = {
  groups: process.env.VUE_APP_FEATURE_FLAG_GROUPS === "true",
};

// Add watch for appcuse

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  // watch: {
  //   $route: () => {
  //     window.Appcues.page();
  //   },
  // },
}).$mount("#app");
